import React, { useEffect, useRef } from "react";
import { ActivityIndicator, Animated, View } from "react-native";
import logo from "./../assets/images/logo.png";

function Loading({ spinner = false }) {
  const opRef = useRef(new Animated.Value(1)).current;
  const animRef = useRef();

  useEffect(() => {
    if (!spinner) {
      animRef.current = Animated.loop(
        Animated.sequence([
          Animated.timing(opRef, {
            toValue: 0.2,
            duration: 2000,
            useNativeDriver: false,
          }),
          Animated.timing(opRef, {
            toValue: 1,
            duration: 2000,
            useNativeDriver: false,
          }),
        ])
      ).start();
    }
  }, []);

  return (
    <View
      style={[
        {
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
        },
        spinner
          ? {
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              backgroundColor: "#00000030",
            }
          : {},
      ]}
    >
      {spinner ? (
        <ActivityIndicator size="large" color="white" />
      ) : (
        <Animated.Image
          source={logo}
          style={{
            width: 100,
            height: 100,
            opacity: opRef,
          }}
        />
      )}
    </View>
  );
}

export default Loading;
